import React, { useEffect, useState } from "react";
// import ivy from '../../assets/ivy_logo_min.png';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow,
  Polyline,
} from "react-google-maps";


const Map =(props:any)=>{


let centerLocation =
  props.allBusesPositions?.length > 0
    ? props.allBusesPositions[props.allBusesPositions?.length -1]
    : {lat: 29.98, lng: 31.32};
 
  return(
    <div>
            <div className="my-4">
       <GoogleMap
          defaultZoom={16}
          defaultCenter={
          
             {lat: +centerLocation?.lat, lng: +centerLocation?.lng} 
          }
          center={
            { lat: +centerLocation?.lat, lng: +centerLocation?.lng }
          }
        >

            {
                props.allBusesPositions?.map((postion:any)=>{
                    let foundBus = props.buses?.find((bus:any)=> bus.id == postion.bus_id)
                    if(!foundBus) return null;
                    return (
                        <Marker
                        // marker for the first driver location point only
                        key={Math.random() * 1.2}
                        position={{lat :+postion.lat , lng :+postion.lng}}
                        icon={
                          "https://maps.gstatic.com/mapfiles/ms2/micons/cabs.png"
                        }
                      >
                       
                          <InfoWindow options={{ disableAutoPan: true }} >
                            {/* <span>{mark.stdPostion}</span> */}
                            <>
                              <div >
                                {" "}
                                <p style={{fontWeight:"bold" , fontSize:"15px" }}>Bus Number :{foundBus?.busnumber}</p>
                                <p style={{fontWeight:"bold" , fontSize:"15px" ,backgroundColor:`${postion?.speed >60 ?"red" :"white"}` ,color:`${postion?.speed >60 ?"white" :"black"}`}}>Bus Speed :{postion?.speed}</p>
                               
                              </div>
                            </>
                          </InfoWindow>
                       
                      </Marker>
                    )
                })
            }
         
         
           
          
       
        </GoogleMap>
      </div>

    </div>
  )
}

export default withScriptjs(withGoogleMap(Map));
